import React, { useState, useEffect } from 'react';

import AgencyEntity from '../../Components/AgencyEntity'
import ModalWarn from '../../Components/Modal/Warn/index'
import { horarioPadraoLabelFactory, horariosPadraoLabelSemRepeticao } from '../../utils';
import { estados } from '../../constants'

export default function AddAgencyEntity(props) {
    const [horarioPadraoAtendimentoOptions, setHorarioPadraoAtendimentoOptions] = useState([]);
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)
    const [ loadingAdd, setLoadingAdd ] = useState(false);    
    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");
    const [ stateOptions ] = useState(estados);
    const [ municipioOptions, setMunicipioOptions ] = useState([])
    const [loadingMunicipios, setLoadingMunicipios] = useState(false);
    const [msgErrorAccreditationDate, setMsgErrorAccreditationDate] = useState();

    useEffect(()=>{   
        async function loadWorkingHoursOptions() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : ""
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaHorariosAtendimentoOrgao`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
    
                        var horarios = [];
                        var obj = {};

                        data.forEach((horariosDoOrgao) => {
                            obj = horarioPadraoLabelFactory(horariosDoOrgao);

                            horarios.push(obj);
                        });

                        setHorarioPadraoAtendimentoOptions(horariosPadraoLabelSemRepeticao(horarios));
                    });
                } else {
                    console.log('Error request to /gestao/orgao/listaHorariosAtendimentoOrgao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }
        loadWorkingHoursOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

     // ================================================================================

    async function listaMunicipios(uf) {
        setLoadingMunicipios(true);
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                uf: uf
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/listaMunicipios`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data) {

                    var municipios = [];
                    var obj = {};

                    data.forEach((h) => {
                        obj = {
                            value: h.CODIGO_MUNICIPIO,
                            label: h.NOME_MUNICIPIO
                        };

                        municipios.push(obj);
                    });

                    setMunicipioOptions(municipios);
                });
            }
            setLoadingMunicipios(false);
        }).catch(function(err) {
            setLoadingMunicipios(false);
            console.error('Failed retrieving information', err);
        });
    }

    const onSubmitAgencyData = async (data) => {

        setLoadingAdd(true);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined, //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "", //Neste caso, o cpf_atendente se refere ao gestor que está cadastrando (que está atendendo)
                nome_orgao: data.nome_orgao,
                nome_rede_atendimento: data.nome_rede_atendimento,
                abrangencia: data.abrangencia,
                uf: data.uf,
                codigo_municipio: data.codigo_municipio,
                horarios: data.horarios,
                atendimento_presencial: data.atendimento_presencial,
                data_credenciamento: data.data_credenciamento,
                referencia_autorizacao: data.referencia_autorizacao,
                orgaos_autorizados: data.orgaos_autorizados,
                realiza_atendimento: data.realiza_atendimento
            }),
        };
         
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/orgao/cadastraOrgao`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function(data_request) {
                    if (props.location.state?.returnTo) {
                        props.history.push(props.location.state?.returnTo, {...props.location.state, addedAgency: {
                                                                                value: data_request.newAgency.codigo_orgao,
                                                                                label: data_request.newAgency.nome_orgao
                                                                            }});
                    } else {
                        const agency_added = {
                            message: data_request.messages ? data_request.messages[0].message : data_request.message
                        }
                        setLoadingAdd(false);
                        
                        props.history.push('gerenciarOrgao', agency_added);
                    }
                    
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    data.errorCode = data.messages ? data.messages[0].errorCode : data.errorCode
                    data.message = data.messages ? data.messages[0].message : data.message
                    if (!!data.errorCode && !!data.message) {
                        if (data.errorCode === 'ACCREDITATION_DATE_INVALID') {
                            setMsgErrorAccreditationDate(data.message);
                        } else {
                            setMessageError(data.message);
                            setModalError(true);
                        }
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                    }

                    setLoadingAdd(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingAdd(false)
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingAdd(false);
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    };
 
    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <AgencyEntity
                pageTitle='Cadastro da rede de atendimento' 
                workingHoursOptions={horarioPadraoAtendimentoOptions}
                setWorkingHoursOptions={setHorarioPadraoAtendimentoOptions}
                onSubmitData={onSubmitAgencyData} 
                stateOptions={stateOptions}
                loadingMunicipality={loadingMunicipios}
                listMunicipality={listaMunicipios}
                municipalityOptions={municipioOptions}
                loadingAdd={loadingAdd}
                setLoading={setLoadingAdd}
                modalError ={modalError} 
                setModalError={setModalError} 
                setMessageError={setMessageError} 
                setMsgErrorAccreditationDate={setMsgErrorAccreditationDate}
                msgErrorAccreditationDate={msgErrorAccreditationDate}
                messageError={messageError} 
                buttonCancelRoute= {(props.location.state?.returnTo) ? props.location.state?.returnTo : '/gerenciarOrgao'} 
                buttonCancelRouteToDataState={(props.location.state?.returnTo)? props.location.state : undefined}
                history={props.history} 
            />
        </>
    );
}